import React from 'react';
import Reactdom from 'react-dom';
import App from './App'

import io from 'socket.io-client'

import { Provider } from 'react-redux'
import { createStore } from 'redux'

// const ENDPOINT = "http://localhost:5000"
const ENDPOINT = "https://superchat-application.herokuapp.com/"



let rooms = [
    { name : "car" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "sports" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "technology" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name : "features" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "anime" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "comics" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "js" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "programming" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "architecture" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "physics" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "biology" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
    {name :  "mems" , info : "Some random info about the group you are to join, choose best group as per your likes and interest. Enjoy Chatting!!!" , activeusers : []},
]

const initialState = {
    username: '',
    room: { name: '', info: '', activeusers: [] },
    message: '',
    messages: [],
    socket: null,
    allusers: [],
    rooms : rooms
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "NEW_MESSAGE":
            return {
                ...state,
                messages: [...state.messages, { user: action.payload.user, message: action.payload.message, date: action.payload.date }]
            }
        case "LOGIN":
            let new_state_login =  {
                ...state,
                username: action.payload.name,
                socket : io(ENDPOINT)
            }
            new_state_login.socket.emit('join', { username: new_state_login.username, room:"none" })
            return new_state_login;
        case "SELECT_GROUP":
            const new_state = { ...state, room: action.payload.group }

            if (state.socket == null) {
                new_state.socket = io(ENDPOINT);
            }
            else {
                new_state.socket.disconnect();
                new_state.socket = io(ENDPOINT);
            }
            new_state.socket.emit('join', { username: new_state.username, room: new_state.room.name })
            new_state.socket.emit('getusers', { room: new_state.room.name })
            new_state.messages = [];
            return new_state;

        case "GET_USERS":
            return {
                ...state,
                allusers: action.payload.name
            }
        case "ADD_NEW_GROUP":
            return {
                ...state , 
                rooms : [{
                    name : action.payload.name , 
                    info : action.payload.info
                } , ...state.rooms]
            }
        default:
            return state;
    }
}

const store = createStore(reducer);

Reactdom.render(
    <Provider store={store}>
        <App />
    </Provider>
    , document.getElementById('root'));